/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefreshDto } from '../../models/refresh-dto';
import { TokensDto } from '../../models/tokens-dto';

export interface AuthControllerRefreshToken$Params {
      body: RefreshDto
}

export function authControllerRefreshToken(http: HttpClient, rootUrl: string, params: AuthControllerRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<TokensDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerRefreshToken.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokensDto>;
    })
  );
}

authControllerRefreshToken.PATH = '/auth/refresh-token';
